export const setOverlaySessionStorage = ( element, value ) => {
	if ( element && value ) {
		sessionStorage.setItem( element.getAttribute( 'id' ), value );
	}
};
export const getOverlaySessionStorage = ( element ) => {
	if ( element ) {
		return sessionStorage.getItem( element.getAttribute( 'id' ) );
	}
	return null;
};
